<div [ngStyle]="{ 'background-image': 'url(' + (coverImage$ | async)?.imagePath + ')' }" class="background">
  <div class="block-grid justify-content-end">
    <app-cover-filter-section></app-cover-filter-section>
    <app-cover-agent-section *ngIf="showAgentInfo"></app-cover-agent-section>
  </div>
</div>
